/**
 * @link https://span.studio
 * @copyright Copyright (c) Span Studio LLC
 * @license https://github.com/Span-Studio/sta100-craft5/blob/main/LICENSE.md
 * 
 * Text Editor.
 * WYSIWYG editor for front-end entry forms. 
 * Wrapper around Quilljs. 
 * 
 * @author John Pobojewski <https://john.pobojewski.com
 * @link https://quilljs.com/
 */

import Quill from 'quill';
import "quill/dist/quill.core.css";

class TextEditor {
	normalizeHtml(html){
		if (typeof html !== 'string') {
			return '';
		}

		return html
			.replace(/&nbsp;|&#160;|&#xA0;/gi, ' ')
			.replace(/\u00A0/g, ' ');
	}

	init($selector, $textarea){
		console.log("TextEditor.js: init()");
		const textarea = document.querySelector($textarea);
		const editor = document.querySelector($selector);
		const initialHtml = this.normalizeHtml(textarea?.value || editor?.innerHTML || '');

		if (textarea) {
			textarea.value = initialHtml;
		}

		if (editor) {
			editor.innerHTML = initialHtml;
		}

		const quill = new Quill($selector, {
			modules: {
				toolbar: [
					['bold', 'italic', 'link']
				]
			},
			theme: 'snow',
		});

		quill.on('text-change', (delta, oldDelta, source) => {
		  textarea.value = this.normalizeHtml(quill.getSemanticHTML());
		});
	}
}

export default new TextEditor();
